const IndexadoresModule = {
    state: {
        indexadores: [],
        coresAtivos: [],
        quantidadeAtivos: 0
    },
    getters: {
        getIndexadores(state) {
            if (!state.indexadores || state.indexadores.length <= 0) { // não possui indexadores carregados
                state.indexadores = [];
                // Os indexadores estão nos arquivos .env
                let indexadores = process.env.VUE_APP_INDEXADORES.split("|");
                state.indexadores = indexadores.map(el => {
                    let dados = el.split(";");
                    return { codigoIndexador: Number.parseInt(dados[0]), nomeIndexador: dados[1], selecionado: dados[0] == 1 };
                })
            } else if (state.indexadores.filter(el => el.selecionado).length == 0) {
                state.indexadores.find(el => el.codigoIndexador == 1).selecionado = true;
            }

            return state.indexadores;
        },
        getSelecionados(state) {
            return state.indexadores.filter(el => el.selecionado);
        },
        getCoresAtivos(state) {
            return state.coresAtivos;
        },
        getQuantidadeAtivos(state) {
            return state.quantidadeAtivos;
        }
    },
    mutations: {
        setIndexadores(state, indexadores) {
            state.indexadores = indexadores;
        },
        setSelecionados(state, indexadores) {
            state.indexadores.forEach(el => {
                el.selecionado = indexadores.includes(el.codigoIndexador);
            });
        },
        setCoresAtivos(state, cores) {
            state.coresAtivos = cores;
        },
        setQuantidadeAtivos(state, quantidade) {
            state.quantidadeAtivos = quantidade;
        },
        addAtivo(state) {
            state.quantidadeAtivos++;
        },
        removeAtivo(state) {
            state.quantidadeAtivos--;
        }
    },
    actions: {
        
    }
}

export default IndexadoresModule;